import { useContext, useEffect } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Modal, Stack } from '@mui/material';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import { ToolContext } from '../../../../core/context/ToolContext';
import { useLocation, useHistory } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import { EmptyList } from '../../../../core/global/realproperty/Index';
import { Visibility as VisibilityIcon, Close as CloseIcon } from '@mui/icons-material';
import dayjs from "dayjs";

export const AgentApplication = () => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { agents } = realproperty_state;
    const nav = useHistory();
    const view = new URLSearchParams(useLocation().search).get("view");
    // for infinite scroll states (other way of infinite scroll implementaion)
    const __init = async (val) => {
        if (val === 0) {
            agents.set((p) => ({ ...p, agentsLoader: true,  agentsInftScroll: true })) 
        }
        agents.set((p) => ({ ...p, agentsIsLoading: true }))
        const res_list = await rqx.get(`<<tool>>/${env()}/propertyListing/read_agent_application`, { 
            lastId: val,
            limit: 15,
            comp_id: tool_state.__SESSION.data.uaccess[0].company_id,
        })
        if (res_list) {
            const last_id = res_list.length > 0 ? res_list[res_list.length - 1].id : val;
            agents.set((p) => ({ ...p, agentsLastId: last_id })) 
            if (val === 0 || val === undefined || val === "") {
                agents.set((p) => ({ ...p, agentsList: res_list })) 
            } else {
                agents.set((p) => ({ ...p, agentsList: [...p.agentsList, ...res_list] })) 
            }
            if (res_list.length < 15) {
                agents.set((p) => ({ ...p, agentsInftScroll: false, agentsHasMore: false })) 
            }
        }
        agents.set((p) => ({ ...p, agentsIsLoading: false, agentsLoader: false })) 
    };

    const loadMoreData = async () => {
        if (agents.data.agentsCooldown || agents.data.agentsIsLoading || !agents.data.agentsHasMore) return;
        agents.set((p) => ({ ...p, agentsCooldown: true })) 
        await __init(agents.data.agentsLastId);
        setTimeout(() => agents.set((p) => ({ ...p, agentsCooldown: false })) , 500);
    };

    useEffect(() => {
        agents.set((p) => ({
            ...p,
            agentsList: [],
            agentsLoader: false,
            agentsModal: false,
            agentsInftScroll: true,
            agentsIsLoading: false,
            agentsCooldown: false,
            agentsHasMore: true,
            agentsLastId: 0,
        }))
        __init(0);
        // eslint-disable-next-line
    }, []);

    const viewAgent = (id) => {
        nav.push(`/realproperty/agent-application?view=${window.btoa(id)}`)
        agents.set((p) => ({...p, agentsModal: true}))
    }

    const closeModal = () => {
        nav.push(`/realproperty/agent-application`)
        agents.set((p) => ({...p, agentsModal: false}))
    }

    const getMobileNum = (num) => JSON.parse(num)?.contact_num || "N/A";

    return (
        <Box mt="1rem">
            { agents.data.agentsLoader ?
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
            :
                agents.data.agentsList.length === 0 ? 
                    <EmptyList text="No agent application have been received yet."/>
                :
                <>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead sx={(theme) => ({ bgcolor: theme.palette.primary.main })}>
                                <TableRow>
                                    <TableCell align="center" sx={{ color: "white", width: "4rem", }}>No.</TableCell>
                                    <TableCell align="left" sx={{ color: "white", width: "8rem" }}>Date Applied</TableCell>
                                    <TableCell align="left" sx={{ color: "white" }}>Name</TableCell>
                                    <TableCell align="left" sx={{ color: "white", width: "10rem" }}>Mobile Number</TableCell>
                                    <TableCell align="left" sx={{ color: "white" }}>Email</TableCell>
                                    <TableCell align="center" sx={{ color: "white", width: "5rem" }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {agents.data.agentsList?.map((v, k) => (
                                <TableRow key={k}>
                                    <TableCell component="th" scope="row" align="center">
                                        {agents.data.agentsList.length - k}
                                    </TableCell>
                                    <TableCell align="left">{dayjs(v.created_at).format("MM/DD/YYYY")}</TableCell>
                                    <TableCell align="left">{v.first_name} {v.last_name}</TableCell>
                                    <TableCell align="left">{getMobileNum(v.contact_info)}</TableCell>
                                    <TableCell align="left">{v.email || "N/A"}</TableCell>
                                    <TableCell align="center"><VisibilityIcon onClick={() => viewAgent(v.id)} fontSize="small" sx={{ cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" } }}/></TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Modal open={agents.data.agentsModal} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Box width="400px" bgcolor="#fff" borderRadius="8px" p="1.5rem">
                            <Stack flexDirection="row" justifyContent="space-between">
                                <Typography fontWeight="600" fontSize={20}>Agent Application</Typography>
                                <CloseIcon onClick={() => closeModal()} sx={{ cursor: "pointer", transition: "0.25s" , "&:hover": { backgroundColor: "#f0f2f4" } }}/>
                            </Stack>
                            { agents.data.agentsList?.filter(v => v.id === Number(window.atob(view))).map(v => (
                                <Stack my="1.5rem" gap="1rem" px="0.5rem" key={v.id}>
                                    <Typography><b>Date Applied:</b> {dayjs(v.created_at).format("MM/DD/YYYY")}</Typography>
                                    <Typography><b>Name:</b> {v.first_name} {v.last_name}</Typography>
                                    <Typography><b>Mobile Number:</b> {v.mobile_num || "N/A"}</Typography>
                                    <Typography><b>Email:</b> {v.email || "N/A"}</Typography>
                                    <Typography><b>Address:</b> {v.street_building_num} {v.barangay_name} {v.city_name} {v.province_name}</Typography>
                                    <Typography><b>Message:</b> {v.message}!</Typography>      
                                </Stack>
                            ))}                          
                        </Box>
                    </Modal>
                    {agents.data.agentsInftScroll && agents.data.agentsHasMore && (
                        <Box sx={{ mt: "2rem" }}>
                            <Waypoint onEnter={loadMoreData}>
                                <Box display="flex" justifyContent="center" my={2}>
                                    <SnakeLoader
                                        bg="#11783C"
                                        size="12px"
                                        distance="8px"
                                    />
                                </Box>
                            </Waypoint>
                        </Box>
                    )}
                </>
            }
        </Box>
    )
}
